/**
 * Rollout determinístico da coleta por sessão. Mesma conta de backend/inteligencia/amostra.py:
 * FNV-1a 32 bits do session_id, módulo 100; na coleta quando balde < percentual.
 */
export function fnv1a32(texto) {
    let h = 0x811c9dc5;
    // UTF-8 sem TextEncoder (navegador antigo e jsdom não têm): encodeURIComponent dá os
    // bytes em %XX; o resto já é ASCII.
    const utf8 = unescape(encodeURIComponent(String(texto || '')));
    for (let i = 0; i < utf8.length; i += 1) {
        h ^= utf8.charCodeAt(i);
        h = Math.imul(h, 0x01000193) >>> 0;
    }
    return h >>> 0;
}

export function balde(sessionId) {
    return fnv1a32(sessionId) % 100;
}

export function naAmostra(sessionId, percentual) {
    const p = Number(percentual) || 0;
    if (p <= 0) return false;
    if (p >= 100) return true;
    return balde(sessionId) < p;
}
